<div class="container-fluid">
  <div class="row">
    <!--  Only Large and Normal Desktop HTML5 Goes here... -->
    <div *ngIf='screenWidth > 1230'>
      <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

      <div (window:orientationchange)="screenRotate($event)">
        <div class="bmw-lg-techTrainManual-main">
          <!-- top panel control goes here... -->
          <div class="col-lg-12 bmw-techTrainManual-control bmw-horizontal-align-center" style="float:left;">
            <div [ngClass]="{'bmw-toggle-color-clicked': showAllFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showAllFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showAllFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showAllFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showAll()">
              ALL </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showNewFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showNewFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showNewFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showNewFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showNew()">
              NEW
              <div class="badge" *ngIf="totalNewCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{totalNewCount}}</div>
            </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showRecentFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showRecentFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showRecentFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showRecentFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showRecent()">
              HISTORY </div>
          </div>

          <div class="bmw-no-gutter col-lg-12 bmw-techTrainManual-content">

            <div class="col-lg-12">
              <div class="col-lg-9 bmw-lg-techTrainManual-content-header">
                Technical Training Manuals
              </div>
              <!-- search training material within existing array -->
              <div class="col-lg-3 text-right" role="search" style="margin-top: 25px;">
                <form class="input-group" name="findManuals">
                  <input [disabled]="techTrainHandleErr.bmwAppError().flag" type="text" class="form-control" size=15 style="height:40px;font-size:17px;"
                    placeholder="Find Manual" name="techTrainManual" id="techTrainManual" [(ngModel)]="search4Manual">
                  <div class="input-group-btn">
                    <button class="btn btn-default bmw-techTrainManual-content-header-search" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="col-lg-12">
              <!-- show error message if API disconnect or no data to show -->
              <div class="alert alert-danger" *ngIf="techTrainHandleErr.bmwAppError().flag" style="margin-top:20px;">{{techTrainHandleErr.bmwAppError().message}}</div>
              <div *ngIf="!techTrainHandleErr.bmwAppError().flag">
                <div class="divTable bmw-techTrainManualTable">
                  <div class="divTableBody">

                    <div class="alert alert-danger" style="margin-top:20px;" *ngIf="search4Manual != null && ((allTechTrainingManuals | searchFilter: 'documentNumber,documentTitle': search4Manual).length === 0); else showSortControlBlock">
                      The technical training manual search key was not found in any record
                    </div>

                    <ng-template #showSortControlBlock>
                      <!-- sort either asc or desc control icons -->
                      <div class="col-lg-12 divTableRow" *ngIf="allTechTrainingManuals">
                        <div class="col-lg-3 pointer divTableCell" (click)="sortBy('documentNumber')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentNumber' && isDesc), 'fa-sort-desc': (column == 'documentNumber' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-lg-6 pointer divTableCell" (click)="sortBy('documentTitle')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentTitle', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentTitle' && isDesc), 'fa-sort-desc': (column == 'documentTitle' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-lg-3 divTableCell">
                          <i class="fa"></i>
                        </div>
                      </div>
                    </ng-template>
                    <div class="alert alert-warning" *ngIf='errorMessage.length > 0'>{{errorMessage}}</div>
                    <div class="col-lg-12 divTableRow" *ngFor="let techTrainingManual of allTechTrainingManuals 
                      | searchFilter: 'documentNumber,documentTitle': search4Manual  
                      | sortBy: {property: column, direction: direction}
                      | paginate: { itemsPerPage: 10, currentPage: p };
                      let index = index">
                      <a href="mount/tech_training_manual/{{techTrainingManual.documentFileName}}" (click)='addManualToHistory(showRecentFlag, techTrainingManual.id, techTrainingManual.documentNumber)' target="_blank">
                        <div class="col-lg-3 divTableCell">{{ techTrainingManual.documentNumber }}</div>
                        <div class="col-lg-6 divTableCell">{{ techTrainingManual.documentTitle }}</div>
                        <div class="col-lg-3 divTableCell text-right">
                          <a class="bmw-align-icon-with-text" [ngClass]="{'mini-techTrainManualTable-icon-pdf' : APP_SETTINGS.isMINI === 'true','rr-techTrainManualTable-icon-pdf' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-techTrainManualTable-icon-pdf': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">
                            <i class="material-icons">
                              {{ techTrainingManual.documentFileType === "pdf" ? "picture_as_pdf" : (techTrainingManual.documentFileType === "zip" || techTrainingManual.documentFileType ===
                              "exe") ? "file_download" : techTrainingManual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                            </i>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <!-- footer of table to control the pagination  -->
                <pagination-controls (pageChange)="p = $event;pageNumChange( $event)"></pagination-controls>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
      <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->
      <div (window:orientationchange)="screenRotate($event)">

        <div class="bmw-md-techTrainManual-main">

          <!-- top panel control goes here... -->
          <div class="col-md-12 bmw-techTrainManual-control bmw-horizontal-align-center" style="float:left;">
            <div [ngClass]="{'bmw-toggle-color-clicked': showAllFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showAllFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showAllFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showAllFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showAll()">
              ALL </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showNewFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showNewFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showNewFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showNewFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showNew()">
              NEW
              <div class="badge" *ngIf="totalNewCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{totalNewCount}}</div>
            </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showRecentFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showRecentFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showRecentFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showRecentFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showRecent()">
              HISTORY </div>
          </div>

          <div class="bmw-no-gutter col-md-12 bmw-techTrainManual-content">

            <div class="col-md-12">
              <div class="bmw-no-gutter col-md-8 bmw-md-techTrainManual-content-header">
                Technical Training Manuals
              </div>
              <!-- search training material within existing array -->
              <div class="col-md-4 text-right" role="search" style="margin-top: 25px;">
                <form class="input-group" name="findManuals">
                  <input [disabled]="techTrainHandleErr.bmwAppError().flag" type="text" class="form-control" size=15 style="height:40px;font-size:17px;"
                    placeholder="Find Manual" name="techTrainManual" id="techTrainManual" [(ngModel)]="search4Manual">
                  <div class="input-group-btn">
                    <button class="btn btn-default bmw-techTrainManual-content-header-search" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="col-md-12">
              <!-- show error message if API disconnect or no data to show -->
              <div class="alert alert-danger" *ngIf="techTrainHandleErr.bmwAppError().flag" style="margin-top:20px;">{{techTrainHandleErr.bmwAppError().message}}</div>
              <div *ngIf="!techTrainHandleErr.bmwAppError().flag">
                <div class="col-md-12 divTable bmw-techTrainManualTable">
                  <div class="divTableBody">

                    <div class="alert alert-danger" style="margin-top:20px;" *ngIf="search4Manual != null && ((pagerService.allItems | searchFilter: 'documentNumber,documentTitle': search4Manual).length === 0); else showSortControlBlock">
                      The technical training manual search key was not found in any record
                    </div>

                    <ng-template #showSortControlBlock>
                      <!-- sort either asc or desc control icons -->
                      <div class="col-md-12 divTableRow" *ngIf="pagerService.pagedItems">
                        <div class="col-md-3 pointer divTableCell" (click)="sortBy('documentNumber')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentNumber' && isDesc), 'fa-sort-desc': (column == 'documentNumber' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-md-6 pointer divTableCell" (click)="sortBy('documentTitle')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentTitle', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentTitle' && isDesc), 'fa-sort-desc': (column == 'documentTitle' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-md-3 divTableCell">
                          <i class="fa"></i>
                        </div>
                      </div>
                    </ng-template>

                    <div class="col-md-12 divTableRow" *ngFor="let techTrainingManual of allTechTrainingManuals 
                    | searchFilter: 'documentNumber,documentTitle': search4Manual  
                    | sortBy: {property: column, direction: direction}
                    | paginate: { itemsPerPage: 10, currentPage: p };
                    let index = index">
                      <a href="mount/tech_training_manual/{{techTrainingManual.documentFileName}}" (click)='addManualToHistory(showRecentFlag, techTrainingManual.id, techTrainingManual.documentNumber)' target="_blank">
                        <div class="col-md-3 divTableCell">{{ techTrainingManual.documentNumber }}</div>
                        <div class="col-md-6 divTableCell">{{ techTrainingManual.documentTitle }}</div>
                        <div class="col-md-3 divTableCell text-right">
                          <a class="bmw-align-icon-with-text" [ngClass]="{'mini-techTrainManualTable-icon-pdf' : APP_SETTINGS.isMINI === 'true','rr-techTrainManualTable-icon-pdf' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-techTrainManualTable-icon-pdf': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">
                            <i class="material-icons">
                              {{ techTrainingManual.documentFileType === "pdf" ? "picture_as_pdf" : (techTrainingManual.documentFileType === "zip" || techTrainingManual.documentFileType ===
                              "exe") ? "file_download" : techTrainingManual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                            </i>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- footer of table to control the pagination  -->
              <pagination-controls (pageChange)="p = $event;pageNumChange( $event)"></pagination-controls>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
      <div (window:orientationchange)="screenRotate($event)">
        <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

        <div class="bmw-sm-techTrainManual-main">

          <!-- top panel control goes here... -->
          <div class="col-sm-12 bmw-techTrainManual-control bmw-horizontal-align-center" style="float:left;">
            <div [ngClass]="{'bmw-toggle-color-clicked': showAllFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showAllFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showAllFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showAllFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showAll()">
              ALL </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showNewFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showNewFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showNewFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showNewFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showNew()">
              NEW
              <div class="badge" *ngIf="totalNewCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{totalNewCount}}</div>
            </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showRecentFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showRecentFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showRecentFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showRecentFlag}"
              class="bmw-techTrainManual-control-content pointer" aria-hidden="true" (click)="showRecent()">
              HISTORY </div>
          </div>

          <div class="bmw-no-gutter col-sm-12 bmw-techTrainManual-content">

            <div class="col-sm-12">
              <div class="bmw-no-gutter col-sm-12 bmw-sm-techTrainManual-content-header">
                Technical Training Manuals
              </div>
              <!-- search training material within existing array -->
              <div class="col-sm-12 text-right" role="search" style="margin-top: 25px;">
                <form class="input-group" name="findManuals">
                  <input [disabled]="techTrainHandleErr.bmwAppError().flag" type="text" class="form-control" size=15 style="height:40px;font-size:17px;"
                    placeholder="Find Manual" name="techTrainManual" id="techTrainManual" [(ngModel)]="search4Manual">
                  <div class="input-group-btn">
                    <button class="btn btn-default bmw-techTrainManual-content-header-search" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="col-sm-12">
              <!-- show error message if API disconnect or no data to show -->
              <div class="alert alert-danger" *ngIf="techTrainHandleErr.bmwAppError().flag" style="margin-top:20px;">{{techTrainHandleErr.bmwAppError().message}}</div>
              <div *ngIf="!techTrainHandleErr.bmwAppError().flag">
                <div class="col-sm-12 divTable bmw-techTrainManualTable">
                  <div class="divTableBody">

                    <div class="alert alert-danger" style="margin-top:20px;" *ngIf="search4Manual != null && ((pagerService.allItems | searchFilter: 'documentNumber,documentTitle': search4Manual).length === 0); else showSortControlBlock">
                      The technical training manual search key was not found in any record
                    </div>

                    <ng-template #showSortControlBlock>
                      <!-- sort either asc or desc control icons -->
                      <div class="col-sm-12 divTableRow" *ngIf="pagerService.pagedItems">
                        <div class="col-sm-3 pointer divTableCell" (click)="sortBy('documentNumber')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentNumber' && isDesc), 'fa-sort-desc': (column == 'documentNumber' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-sm-6 pointer divTableCell" (click)="sortBy('documentTitle')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentTitle', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentTitle' && isDesc), 'fa-sort-desc': (column == 'documentTitle' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-sm-3 divTableCell">
                          <i class="fa"></i>
                        </div>
                      </div>
                    </ng-template>

                    <div class="col-sm-12 divTableRow" *ngFor="let techTrainingManual of allTechTrainingManuals 
                    | searchFilter: 'documentNumber,documentTitle': search4Manual  
                    | sortBy: {property: column, direction: direction}
                    | paginate: { itemsPerPage: 10, currentPage: p };
                    let index = index">
                      <a href="mount/tech_training_manual/{{techTrainingManual.documentFileName}}" (click)='addManualToHistory(showRecentFlag, techTrainingManual.id, techTrainingManual.documentNumber)' target="_blank">
                        <div class="col-sm-3 divTableCell">{{ techTrainingManual.documentNumber }}</div>
                        <div class="col-sm-6 divTableCell">{{ techTrainingManual.documentTitle }}</div>
                        <div class="col-sm-3 divTableCell text-right">
                          <a class="bmw-align-icon-with-text" [ngClass]="{'mini-techTrainManualTable-icon-pdf' : APP_SETTINGS.isMINI === 'true','rr-techTrainManualTable-icon-pdf' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-techTrainManualTable-icon-pdf': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">
                            <i class="material-icons">
                              {{ techTrainingManual.documentFileType === "pdf" ? "picture_as_pdf" : (techTrainingManual.documentFileType === "zip" || techTrainingManual.documentFileType ===
                              "exe") ? "file_download" : techTrainingManual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                            </i>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- footer of table to control the pagination  -->
              <pagination-controls (pageChange)="p = $event;pageNumChange( $event)"></pagination-controls>

            </div>

          </div>

        </div>

      </div>
    </div>

    <div *ngIf='screenWidth > 319 && screenWidth < 767'>
      <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->
      <div (window:orientationchange)="screenRotate($event)">

        <div class="bmw-xs-techTrainManual-main">

          <!-- top panel control goes here... -->
          <div class="col-xs-12 bmw-no-gutter bmw-techTrainManual-control bmw-horizontal-align-center" style="float:left;">
            <div [ngClass]="{'bmw-toggle-color-clicked': showAllFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showAllFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showAllFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showAllFlag}"
              class="bmw-xs-techTrainManual-control-content pointer" aria-hidden="true" (click)="showAll()">
              ALL </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showNewFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showNewFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showNewFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showNewFlag}"
              class="bmw-xs-techTrainManual-control-content pointer" aria-hidden="true" (click)="showNew()">
              NEW
              <div class="badge" *ngIf="totalNewCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{totalNewCount}}</div>
            </div>
            <div [ngClass]="{'bmw-toggle-color-clicked': showRecentFlag && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'mini-toggle-color-clicked': showRecentFlag && APP_SETTINGS.isMINI === 'true','rr-toggle-color-clicked' :showRecentFlag && APP_SETTINGS.isRollsRoyce === 'true', 'bmw-toggle-color-default': !showRecentFlag}"
              class="bmw-xs-techTrainManual-control-content pointer" aria-hidden="true" (click)="showRecent()">
              HISTORY </div>
          </div>

          <div class="bmw-no-gutter col-xs-12 bmw-techTrainManual-content">

            <div class="bmw-no-gutter col-xs-12 bmw-xs-techTrainManual-content-header">
              Technical Training Manuals
            </div>
            <!-- search training material within existing array -->
            <div class="col-xs-12 text-right" role="search" style="margin-top: 15px;margin-bottom:15px;">
              <form class="input-group" name="findManuals">
                <input [disabled]="techTrainHandleErr.bmwAppError().flag" type="text" class="form-control" size=15 style="height:31px;" placeholder="Find Manual"
                  name="techTrainManual" id="techTrainManual" [(ngModel)]="search4Manual">
                <div class="input-group-btn">
                  <button class="btn btn-default bmw-xs-techTrainManual-content-header-search" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                    type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>

            <div class="col-xs-12">
              <!-- show error message if API disconnect or no data to show -->
              <div class="alert alert-danger" *ngIf="techTrainHandleErr.bmwAppError().flag">{{techTrainHandleErr.bmwAppError().message}}</div>
              <div *ngIf="!techTrainHandleErr.bmwAppError().flag">
                <div class="col-xs-12 divTable bmw-xs-techTrainManualTable">
                  <div class="divTableBody">

                    <div class="alert alert-danger" *ngIf="search4Manual != null && ((pagerService.allItems | searchFilter: 'documentNumber,documentTitle': search4Manual).length === 0); else showSortControlBlock">
                      The technical training manual search key was not found in any record
                    </div>

                    <ng-template #showSortControlBlock>
                      <!-- sort either asc or desc control icons -->
                      <div class="col-xs-12 divTableRow" *ngIf="pagerService.pagedItems">
                        <div class="col-xs-3 pointer divTableCell" (click)="sortBy('documentNumber')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentNumber' && isDesc), 'fa-sort-desc': (column == 'documentNumber' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-xs-6 pointer divTableCell" (click)="sortBy('documentTitle')">
                          <i class="fa" [ngClass]="{'fa-sort': column != 'documentTitle', 'fa-sort-asc bmw-sort-control-asc': (column == 'documentTitle' && isDesc), 'fa-sort-desc': (column == 'documentTitle' && !isDesc) }"
                            aria-hidden="true"> </i>
                        </div>
                        <div class="col-xs-3 divTableCell">
                          <i class="fa"></i>
                        </div>
                      </div>
                    </ng-template>

                    <div class="col-xs-12 divTableRow" *ngFor="let techTrainingManual of allTechTrainingManuals 
                    | searchFilter: 'documentNumber,documentTitle': search4Manual  
                    | sortBy: {property: column, direction: direction}
                    | paginate: { itemsPerPage: 10, currentPage: p };
                    let index = index">
                      <a href="mount/tech_training_manual/{{techTrainingManual.documentFileName}}" (click)='addManualToHistory(showRecentFlag, techTrainingManual.id, techTrainingManual.documentNumber)' target="_blank">
                        <div class="col-xs-3 divTableCell">{{ techTrainingManual.documentNumber }}</div>
                        <div class="col-xs-6 divTableCell">{{ techTrainingManual.documentTitle }}</div>
                        <div class="col-xs-3 divTableCell text-right">
                          <a class="bmw-align-icon-with-text" [ngClass]="{'mini-techTrainManualTable-icon-pdf' : APP_SETTINGS.isMINI === 'true','rr-techTrainManualTable-icon-pdf' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-techTrainManualTable-icon-pdf': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">
                            <i class="material-icons">
                              {{ techTrainingManual.documentFileType === "pdf" ? "picture_as_pdf" : (techTrainingManual.documentFileType === "zip" || techTrainingManual.documentFileType ===
                              "exe") ? "file_download" : techTrainingManual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                            </i>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- footer of table to control the pagination  -->
              <pagination-controls (pageChange)="p = $event;pageNumChange( $event)"></pagination-controls>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>